<!-- Halted -->
@if (notificationStatus === SymbolStatus.HALTED) {
  <td-wb-notification notificationType="error"
                      [focusOnInit]="false">
    <span translate="tdWb.tickerSymbol.messages.HALTED"></span>
  </td-wb-notification>
}

<!--SYMBOL ERROR (an expired option is considered in this case since it is invalid) -->
@if (notificationStatus === SymbolStatus.INVALID) {
  <td-wb-notification notificationType="error"
                      [focusOnInit]="false">
    <span translate="tdWb.tickerSymbol.messages.SYMBOL_ERR"></span>
  </td-wb-notification>
}

<!-- Quote error -->
@if (notificationStatus === SymbolStatus.QUOTE_ERROR) {
  <td-wb-notification notificationType="error"
                      [focusOnInit]="false">
    <span translate="tdWb.tickerSymbol.messages.QUOTE_MSG_ERR"></span>
  </td-wb-notification>
}

<!-- Real time quotes - exchange agreements not signed -->
@if (notificationStatus === SymbolStatus.UNSIGNED_AGREEMENT) {
  <td-wb-notification notificationType="warning">
    <span translate="tdWb.tickerSymbol.messages.REALTIME_QUOTES_1"></span>
    <a class="td-wb-link--underlined"
       tdWbHref="link_preferences_agreements"
       translate="tdWb.tickerSymbol.messages.REALTIME_QUOTES_2"></a>
    <span translate="tdWb.tickerSymbol.messages.REALTIME_QUOTES_3"></span>
  </td-wb-notification>
}
